import styled from '@emotion/styled'

import Separator from './component'

export default styled(Separator)``
